/* Decorative motion pauses offscreen, in background tabs, and for reduced motion. */
(function () {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    // Animate only the known Pantopie mark; custom uploaded logos remain untouched.
    const logo = document.querySelector('.gh-navigation-logo img');
    const template = document.querySelector('[data-studio-sunrise]');
    if (logo && template && /\/Logo-solo-dark-1\.svg$/.test(new URL(logo.src).pathname)) {
        logo.replaceWith(template.content.cloneNode(true));
    }
    const brand = document.querySelector('.gh-navigation-logo');
    function replaySunrise() {
        if (reduced.matches || document.documentElement.classList.contains('studio-motion-paused')) return;
        brand.querySelectorAll('.studio-ray').forEach(ray => {
            if (!ray.getAnimations) return;
            ray.getAnimations().forEach(animation => {
                if (animation.animationName === 'studio-ray-wave') {
                    // Replay the existing wave, skipping its quiet lead-in (55%).
                    // CSS delays preserve the same ray-to-ray stagger.
                    animation.currentTime = 3300;
                }
            });
        });
    }
    if (brand) {
        brand.addEventListener('pointerenter', replaySunrise);
        brand.addEventListener('focus', replaySunrise);
    }
    const targets = document.querySelectorAll('.studio-artwork-glow, .gh-navigation-logo img, .studio-sunrise, .studio-dot');
    function update() {
        const stopped = reduced.matches || document.hidden;
        document.documentElement.classList.toggle('studio-motion-paused', stopped);
        document.dispatchEvent(new CustomEvent('studio:motion-change'));

    }
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
            entry.target.classList.toggle('studio-idle-visible', entry.isIntersecting);
        }));
        targets.forEach(target => observer.observe(target));
    }
    document.addEventListener('visibilitychange', update);
    reduced.addEventListener('change', update);
    update();
}());
